/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback, useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useProductsApi } from '../../../../apis';
import { FILE_DOWNLOAD_FORMATS } from '../../../../apis/constants/fileDownloadFormats';
import { downloadFileFromApi } from '../../../../apis/Utilities/downloadFileFromApi';
import { FileExportSelector } from '../../../FileExportSelector';
import { getTrueKeysAsCSV } from '../../../../utils/projections';
import { cleanObject } from '../../../../utils/objectExtensions';

function DataExport(props) {
	const {
		filters,
		dataTestId,
		columnOrder,
		columnVisibility,
		sort,
		isLoading,
	} = props;

	const { t } = useTranslation('common');
	const { pathname } = useLocation();
	const { searchKey } = useParams();
	const { downloadProductList } = useProductsApi();

	const options = useMemo(
		() => [
			{ key: FILE_DOWNLOAD_FORMATS.CSV, value: 'CSV' },
			{ key: FILE_DOWNLOAD_FORMATS.EXCEL, value: 'Excel' },
		],
		[]
	);

	const generateProductFilters = () =>
		cleanObject({
			Product_Category: filters?.category || undefined,
			Plant_Code: filters?.plant || undefined,
		});

	const handleDownload = async (format) => {
		const columnNames = columnOrder.filter((k) => columnVisibility[k]);

		const isSearchPage = pathname.includes('search');

		// Searching is mutually exclusive from filters and status filtering
		const productsFiltersClass = {
			Order_By: sort || 'Design_Number ASC',
			Status: isSearchPage
				? undefined
				: getTrueKeysAsCSV(filters?.status) || undefined,
			Search: isSearchPage ? searchKey : undefined,
			Filters: isSearchPage ? undefined : generateProductFilters(),
		};

		const payload = {
			columnNames,
			filters: productsFiltersClass,
		};

		await downloadFileFromApi({
			format,
			defaultFilenamePrefix: 'MyProducts',
			executeApiCall: () => downloadProductList({ format }, payload),
		});
	};

	return (
		<FileExportSelector
			options={options}
			onDownload={handleDownload}
			label={t('export')}
			isLoading={isLoading}
			dataTestId={dataTestId}
		/>
	);
}

DataExport.propTypes = {
	filters: PropTypes.object,
	sort: PropTypes.string.isRequired,
	dataTestId: PropTypes.string,
	columnOrder: PropTypes.array.isRequired,
	columnVisibility: PropTypes.object,
	isLoading: PropTypes.bool.isRequired,
};

export default DataExport;
